import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import './main.css'
import 'react-toastify/dist/ReactToastify.min.css'
import { StrictMode } from 'react'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
